import { URL_LANGUAGES } from 'tradera-lang/constants.mjs';
export const OPTIONAL_LANG = `/:lang(${URL_LANGUAGES.join('|')})?`;
